import { useQuery } from '@tanstack/react-query';

import { selectActiveAccount, useAuthStore } from '@features/auth';
import type { ApiError } from '@/types/api.types';

import { fetchClient } from '../api/clientsApi';
import type { ClientProfile } from '../types';

export function useClient(clientId: string | undefined) {
  const activeAccount = useAuthStore(selectActiveAccount);
  const accountId = activeAccount?.accountId ?? '';

  return useQuery<ClientProfile, ApiError>({
    queryKey: ['client', accountId, clientId],
    queryFn: () => fetchClient(accountId, clientId as string),
    enabled: !!accountId && !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}
